import React from "react";
import SubscribersReportView from "../../../../views/dashboard/reports/subscribers";

const SubscribersReport = () => {
  return <SubscribersReportView />;
};

export default SubscribersReport;
